<template>
  <span class="badge">
    <vs-chip :color="result ? 'success' : 'danger'" class="p-0 pr-2 pl-2">
      <span v-if="result">Success</span>
      <span v-else>Failed</span>
    </vs-chip>
  </span>
</template>

<script>
export default {
  name: 'AddDbTestConnection',
  props: {
    result: {
      type: Boolean,
      required: true
    }
  }
}
</script>

<style scoped>

</style>
